// extracted by mini-css-extract-plugin
module.exports = {"animation":"Loader_animation__pq04U","nc-loop-squares-anim-2":"Loader_nc-loop-squares-anim-2__21sSM"};